import { createContext, useContext } from 'react';

/**
 * True inside StepCrossfade's LEAVING snapshot — a fresh, inert re-mount of the
 * previous step that only exists to fade out (~240ms). Components with real
 * mount-time side effects read this and stand down, per StepCrossfade's
 * GHOST-MOUNT CONTRACT: HCaptchaGate must not load/render a second live
 * Turnstile widget while the forgot step slides away (2026-09-25 QA audit).
 */
export const StepGhostContext = createContext(false);

export function useIsStepGhost() {
  return useContext(StepGhostContext);
}
